import { PRODUCT_NAMES, getProductSystemNameByAlias } from './cfs-card'

const { FULL_WALLET_CARD, CONSUMER_DEBIT_CARD, BUSINESS_DEBIT_CARD } = PRODUCT_NAMES

/**
 * Used to customize experience such as to identify
 * unique webview completion handler in unexpected error pages,
 * to redirect user to the entry flow.
 */
export const FLOWS = {
  // Flow Modal
  APPLY: 'apply',
  MANAGE: 'profile',
  SUMMARY: 'summary',
  CHANGE_ADDRESS: 'changeAddress',
  ADD_ADDRESS: 'addAddress',
  REPLACE_CARD: 'replaceCard',
  ACTIVATE_CARD: 'activateCard',
  STATIC_PAGE: 'staticPage',
  SET_PIN: 'setPin',
  ENROLL_CARD: 'enrollCard',
  SETUP_FI: 'setupFi',
  ADD_FI_FLOW: 'addFiFlow',
  SHOW_CARD: 'showCard',
  LOW_BALANCE_ALERT: 'lowBalanceAlert',
  EDIT_FUNDING: 'editFunding',
  REQUEST_PHYSICAL_CARD: 'requestPhysicalCard',

  // Main Page
  MANAGE_CARD: 'manageCard',
  REWARDS: 'rewards',

  // v1 Flows
  CHANGE_PIN: 'changePin',
  FUNDING: 'funding',
  VIEW_PIN: 'viewPin',
  
  // XO-PPDC Flow
  XO_PPDC: 'xoPpdc',
}

export const FLOWS_SUPPORTED_PRODUCTS = {
  [FLOWS.ADD_ADDRESS]: [FULL_WALLET_CARD, CONSUMER_DEBIT_CARD, BUSINESS_DEBIT_CARD],
  [FLOWS.CHANGE_ADDRESS]: [FULL_WALLET_CARD, CONSUMER_DEBIT_CARD, BUSINESS_DEBIT_CARD],
  [FLOWS.REPLACE_CARD]: [FULL_WALLET_CARD, CONSUMER_DEBIT_CARD, BUSINESS_DEBIT_CARD],
  [FLOWS.ACTIVATE_CARD]: [FULL_WALLET_CARD, CONSUMER_DEBIT_CARD],
  [FLOWS.SET_PIN]: [FULL_WALLET_CARD, CONSUMER_DEBIT_CARD, BUSINESS_DEBIT_CARD],
  [FLOWS.ENROLL_CARD]: [CONSUMER_DEBIT_CARD],
  [FLOWS.SETUP_FI]: [CONSUMER_DEBIT_CARD],
  [FLOWS.ADD_FI_FLOW]: [CONSUMER_DEBIT_CARD],
  [FLOWS.MANAGE_CARD]: [CONSUMER_DEBIT_CARD],
  [FLOWS.SHOW_CARD]: [CONSUMER_DEBIT_CARD],
  [FLOWS.REQUEST_PHYSICAL_CARD]: [CONSUMER_DEBIT_CARD],
  [FLOWS.XO_PPDC]: [CONSUMER_DEBIT_CARD],
}

export const FPTI_COMMON_BUTTONS = {
  CLOSE: 'closeBtn',
  BACK: 'backBtn',
}

export const SUPPORTED_STEP_DEEPLINKS = {
  // FUNDING: 'FUNDING',
}

export const FPTI_CONTEXT_ID_HEADER = 'x-paypal-fpti-custom-context-id'

export const FPTI_IMPRESSION_PAGE_NAME_FOR_STEPUP = 'redirectingToStepUp'

export const ENROLLMENT_VALUEPROPS_EXPERIMENT_TREATMENT = {
  CTRL: 'CTRL',
  A: 'A',
  B: 'B',
}

export const WALLET_REDIRECT = {
  STATUS: {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
  },
  REASON: {
    CANCEL: 'CANCEL',
  },
}

export const NATIVE_RETURN_URI = {
  NATIVE_PPK_MANAGEMENT: 'NATIVE_PPK_MANAGEMENT',
}

export function isReturnUriToNative(returnUri) {
  if (!returnUri) {
    return false
  }
  const { NATIVE_PPK_MANAGEMENT } = NATIVE_RETURN_URI
  return [NATIVE_PPK_MANAGEMENT].includes(returnUri.toUpperCase())
}

export function isFlowSupported(flowName, productName) {
  if (Array.isArray(FLOWS_SUPPORTED_PRODUCTS[flowName])) {
    return FLOWS_SUPPORTED_PRODUCTS[flowName].includes(getProductSystemNameByAlias(productName))
  }
  return false
}

export const MANAGEMENT_ACTION_TABS = {
  ACTIVITY: 'activity',
  MANAGE: 'manage',
}

export const REWARDS_ACTION_TABS = {
  EXPLORE: 'ucs_offers_tab_all',
  SAVED: 'ucs_offers_tab_active',
}

export const REQUEST_PATH_FLOW_NAME_MAP = {
  fees: 'FEES',
  'add-money': 'ADD_MONEY',
  'add-cash-at-store': 'ADD_CASH_AT_STORE',
  summary: 'SUMMARY',
  rewards: 'REWARDS',
  funding: 'FUNDING',
  cancel: 'CANCEL_CARD',
  'change-pin': 'CHANGE_PIN',
  'view-pin': 'VIEW_PIN',
  'set-pin': 'SET_PIN',
  'create-pin': 'SET_PIN',
  'show-card': 'SHOW_CARD',
  change: 'CHANGE_ADDRESS',
  add: 'ADD_ADDRESS',
  replace: 'REPLACE_CARD',
  activate: 'ACTIVATE_CARD',
  enroll: 'ENROLL_CARD',
  'request-physical-card': 'REQUEST_PHYSICAL_CARD',
}

export const REQUEST_HEADERS = {
  PAYPAL_CLIENT_METADATA_ID: 'paypal-client-metadata-id',
}

export const WEBVIEW_CALLBACK_NAMES_BY_FLOWS = {
  [FLOWS.ACTIVATE_CARD]: 'onActivateCardComplete',
  [FLOWS.REPLACE_CARD]: 'onReplaceCardComplete',
  [FLOWS.ADD_ADDRESS]: 'onAddAddressComplete',
  [FLOWS.SET_PIN]: 'onSetPinComplete',
}
